import React, { Component } from 'react'
import { Link }             from 'react-router-dom'

import './css/attachments.css'

import fileThumbnail from './css/file-thumbnail.png'

export default class Attachments extends Component {

  rememberLast(lastImage) {
    localStorage.lastImage = lastImage
  }

  forgetLast(e) {
    e.target.classList.remove('attachments-highlight-on')
    delete localStorage.lastImage
  }

  render() {
    return !this.props.attachments ? '' : (
      <div className="attachments">
        {this.props.attachments.map((image, n) => (image === 'separator') ? (
          <div key={n} className="attachments-separator" />
        ) : (
          <Link key={n} to={image.url} onClick={() => this.rememberLast(image.uid)} className="attachments-item">
            <img
              src   = {image.thumb_url || fileThumbnail}
              alt   = {image.caption || image.title}
              title = {image.name || image.caption}
            />
            <div
              title       = {image.name || image.caption}
              onMouseOver = {this.forgetLast.bind(this)}
              className   = {`attachments-highlight ${image.uid === localStorage.lastImage ? ' attachments-highlight-on' : ''}`}
            />
          </Link>
        ))}
        <div className="attachments-filler" />
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/attachments.js